import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c381ab24"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "bg-white border-top p-1 text-muted small"
};
const _hoisted_2 = {
  class: "navbar-brand mr-2"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "Powered By"), /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  class: "text-secondary font-weight-bold ml-1",
  href: "https://cn.vuejs.org/"
}, "Vue 3")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_2, [_createElementVNode("strong", null, _toDisplayString(_ctx.$globalParams.real_name), 1)]), _createTextVNode(" Copyright © " + _toDisplayString($data.year) + " . All rights reserved. ", 1)]), _hoisted_3]);
}